/*
  Free Shipping Strikethrough — Rebuy Smart Cart bridge.

  The active mini-cart is the Rebuy app (.rebuy-cart__flyout), which is rendered
  by Rebuy's JS, not by the theme — so we can't add our row in Liquid there.
  This script ADDS a "Shipping: <struck total> FREE SHIPPING" row right after
  Rebuy's subtotal. The value is computed server-side by our own theme view
  (/cart?view=ajax_side_cart -> free-shipping-cart-drawer.liquid), so metafields
  and the sum are always correct.

  Non-destructive by design:
  - Never modifies Rebuy code; only inserts a sibling <div> into Rebuy's DOM.
  - Everything is wrapped in try/catch and null-guarded; if Rebuy's markup ever
    changes, our row simply doesn't appear — the drawer keeps working.
  - Re-runs whenever Rebuy re-renders the cart, so the number stays in sync.
*/
(function () {
  'use strict';

  var MARK = 'data-free-ship-rebuy';
  var pending = false;

  // Pull the already-computed "Shipping" value HTML from our server view.
  function getValueHtml() {
    return fetch('/cart?view=ajax_side_cart', { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('.previewCartTotals.freeShipping .previewCartTotals-value');
          return el ? el.innerHTML.trim() : null;
        } catch (e) { return null; }
      })
      .catch(function () { return null; });
  }

  function inject() {
    pending = false;
    try {
      var flyout = document.querySelector('.rebuy-cart__flyout');
      if (!flyout) return;
      var subtotal = flyout.querySelector('.rebuy-cart__flyout-subtotal');
      if (!subtotal) return;

      getValueHtml().then(function (valueHtml) {
        try {
          if (!valueHtml) return;
          var f = document.querySelector('.rebuy-cart__flyout');
          if (!f) return;
          var st = f.querySelector('.rebuy-cart__flyout-subtotal');
          if (!st) return;

          // If our row already exists, just refresh its value in place — covers
          // cart changes where Rebuy keeps our node (so the price never goes stale).
          var existingAmount = f.querySelector('[' + MARK + '] .fs-amount');
          if (existingAmount) { existingAmount.innerHTML = valueHtml; return; }

          // Deep-clone Rebuy's own subtotal row so ours matches it pixel-for-pixel
          // (same inset/padding/fonts), then swap the label + amount. Inserted as a
          // sibling directly below the subtotal wrapper (Subtotal -> Shipping).
          var wrapper = st.parentElement;
          if (!wrapper || !wrapper.parentNode) return;
          var clone = wrapper.cloneNode(true);
          clone.setAttribute(MARK, '1');
          clone.style.marginTop = '6px';
          var cLabel = clone.querySelector('.rebuy-cart__flyout-subtotal-label');
          var cAmount = clone.querySelector('.rebuy-cart__flyout-subtotal-amount');
          if (!cLabel || !cAmount) return; // unexpected structure -> do nothing (safe)
          cLabel.textContent = 'Shipping';
          cAmount.classList.add('fs-amount');
          cAmount.innerHTML = valueHtml;
          wrapper.parentNode.insertBefore(clone, wrapper.nextSibling);
        } catch (e) { /* fail silently */ }
      });
    } catch (e) { /* fail silently */ }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(inject, 200);
  }

  // Rebuy fires its own events on load / cart change.
  ['rebuy:cart.change', 'rebuy:smartcart.didLoad', 'rebuy:smartcart.show', 'rebuy:cart.ready']
    .forEach(function (ev) { document.addEventListener(ev, schedule); });

  // Fallback: watch the DOM. Rebuy wipes our row when it re-renders, so if the
  // subtotal is present but our row is gone, re-add it.
  try {
    var mo = new MutationObserver(function () {
      var f = document.querySelector('.rebuy-cart__flyout');
      if (f && f.querySelector('.rebuy-cart__flyout-subtotal') && !f.querySelector('[' + MARK + ']')) {
        schedule();
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) { /* ignore */ }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
